import { render, staticRenderFns } from "./DsioPagination.vue?vue&type=template&id=241b4ff0&"
import script from "./DsioPagination.vue?vue&type=script&lang=js&"
export * from "./DsioPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241b4ff0')) {
      api.createRecord('241b4ff0', component.options)
    } else {
      api.reload('241b4ff0', component.options)
    }
    module.hot.accept("./DsioPagination.vue?vue&type=template&id=241b4ff0&", function () {
      api.rerender('241b4ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioPagination.vue"
export default component.exports